import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { H4 } from '../../../components';
import NewListingCard from '../../../components/NewListingCard/NewListingCard';
import { fetchMoreLikeThis, fetchMoreFromSeller } from '../ListingPage.duck';
import { recordListingView } from '../../../util/sessionHistory';

import css from './ListingPageSimilarSections.module.css';

export const ListingPageSimilarSections = props => {
  const {
    listing,
    moreLikeThis = [],
    moreFromSeller = [],
    history,
    favroiteListingIds,
    onAddList,
    dispatch,
    config,
  } = props;

  const listingId = listing?.id?.uuid;
  const categoryL3 = listing?.attributes?.publicData?.categoryLevel3;
  const categoryL2 = listing?.attributes?.publicData?.categoryLevel2;
  const categoryL1 = listing?.attributes?.publicData?.categoryLevel1;
  const color = listing?.attributes?.publicData?.color;
  const priceAmount =
    listing?.attributes?.price?.amount != null
      ? listing.attributes.price.amount / 100
      : null;
  const sellerId = listing?.author?.id?.uuid;

  useEffect(() => {
    if (listingId) {
      recordListingView(listingId);
    }
  }, [listingId]);

  useEffect(() => {
    if (!listingId || !dispatch) return;

    dispatch(
      fetchMoreLikeThis(
        listingId,
        categoryL3,
        config,
        categoryL2,
        categoryL1,
        color,
        priceAmount
      )
    );
    if (sellerId) {
      dispatch(fetchMoreFromSeller(listingId, sellerId, config));
    }
  }, [listingId, categoryL3, categoryL2, categoryL1, color, priceAmount, sellerId, dispatch, config]);

  const hasSimilar = Array.isArray(moreLikeThis) && moreLikeThis.length > 0;
  const hasMoreFromSeller = Array.isArray(moreFromSeller) && moreFromSeller.length > 0;

  if (!hasSimilar && !hasMoreFromSeller) {
    return null;
  }

  const similarListings = moreLikeThis.slice(0, 24);
  const sellerListings = moreFromSeller.slice(0, 24);

  return (
    <div className={css.recommendationsWrapper}>
      <div className={css.sectionsContainer}>
        {/* 1. More Styles For You Grid */}
        {hasSimilar && (
          <section className={css.hotSection}>
            <div className={css.hotSectionHeader}>
              <H4 className={css.h2} as="h2">
                <FormattedMessage
                  id="ListingPage.similarItemsTitle"
                  defaultMessage="MORE STYLES FOR YOU"
                />
              </H4>
            </div>
            <div className={css.gridContainer}>
              {similarListings.map(item => {
                const isLiked =
                  favroiteListingIds && favroiteListingIds.has(item?.id?.uuid);
                return (
                  <div key={item?.id?.uuid} className={css.gridCard}>
                    <NewListingCard
                      rootClassName={classNames(css.indivCard, css.reduceShadow)}
                      history={history}
                      isLiked={isLiked}
                      listing={item}
                      showAuthorInfo={false}
                      showListingName={false}
                      showRating={false}
                      showTimeBadge={true}
                      onAddList={onAddList}
                    />
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {/* 2. More From This Seller Grid (Only if seller has other listings) */}
        {hasMoreFromSeller && (
          <section className={css.hotSection}>
            <div className={css.hotSectionHeader}>
              <H4 className={css.h2} as="h2">
                <FormattedMessage
                  id="ListingPage.moreFromSellerTitle"
                  defaultMessage="MORE FROM THIS SELLER"
                />
              </H4>
            </div>
            <div className={css.gridContainer}>
              {sellerListings.map(item => {
                const isLiked =
                  favroiteListingIds && favroiteListingIds.has(item?.id?.uuid);
                return (
                  <div key={item?.id?.uuid} className={css.gridCard}>
                    <NewListingCard
                      rootClassName={classNames(css.indivCard, css.reduceShadow)}
                      history={history}
                      isLiked={isLiked}
                      listing={item}
                      showAuthorInfo={false}
                      showListingName={false}
                      showRating={false}
                      showTimeBadge={true}
                      onAddList={onAddList}
                    />
                  </div>
                );
              })}
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

ListingPageSimilarSections.propTypes = {
  listing: PropTypes.object,
  moreLikeThis: PropTypes.array,
  moreFromSeller: PropTypes.array,
  history: PropTypes.object,
  favroiteListingIds: PropTypes.object,
  onAddList: PropTypes.func,
  dispatch: PropTypes.func,
  config: PropTypes.object,
};

export default ListingPageSimilarSections;
